import { FunctionComponent, useCallback, useMemo } from 'react'

import config from '@config'
import { useChatbotOnboardingInProcess } from '@hooks/useChatbot/useChatbotOnboarding'
import useTracking from '@hooks/useTracking'

import { AnswerChatbotFeedbackProps } from '../types'
import { getAnswerText, getEntryPoint, trackHandler } from '../utils'
import AnswerFeedback from './AnswerFeedback'

const {
  usersnap: { cuiAnswerWidgetKey },
} = config

const AnswerChatbotFeedback: FunctionComponent<AnswerChatbotFeedbackProps> = ({
  message,
}) => {
  const onboardingInProcess = useChatbotOnboardingInProcess()
  const { traceId, questionData, conversationId } = message
  const handleTracking = useTracking(trackHandler)
  const answer = useMemo(() => getAnswerText(message.content), [message])

  const trackingFuction = useCallback(
    (rating: 'positive' | 'negative') => {
      handleTracking({
        event: 'chatbot_answer_feedback',
        messageId: traceId,
        conversationId,
        isCached: questionData?.isCached,
        isSuggestedQuestion: questionData?.isSuggestedQuestion,
        rating: rating,
      })
    },
    [handleTracking, conversationId, traceId, questionData]
  )

  const customRatingData = useMemo<Record<string, string | number | boolean>>(
    () => ({
      ...(questionData?.text && { question: questionData?.text }),
      ...(answer && { answer }),
      ...(traceId && { messageId: traceId }),
      ...(conversationId && { conversationId }),
      ...(questionData?.context && { context: questionData?.context }),
      entryPoint: getEntryPoint(
        questionData?.isSuggestedQuestion,
        questionData?.isCached
      ),
    }),
    [questionData, answer, traceId, conversationId]
  )

  return (
    <AnswerFeedback
      onboardingInProcess={onboardingInProcess}
      usersnapKey={cuiAnswerWidgetKey}
      trackingFunction={trackingFuction}
      customUsersnapData={customRatingData}
    />
  )
}

export default AnswerChatbotFeedback
